type NavigatorWithBadge = Navigator & {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export const updatePwaBadgeCount = async (count: number): Promise<void> => {
  const nav = navigator as NavigatorWithBadge;
  if (!('setAppBadge' in nav) && !('clearAppBadge' in nav)) {
    return;
  }

  try {
    if (count > 0 && nav.setAppBadge) {
      await nav.setAppBadge(count);
      return;
    }

    if (count <= 0 && nav.clearAppBadge) {
      await nav.clearAppBadge();
    }
  } catch (error) {
    // API availability/permission differs by browser+OS; ignore safely.
    console.debug('PWA badge update skipped:', error);
  }
};
